import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
import { Panel } from '../../components/primitives/Panel';
import type { CommunityRow } from '../outreachTypes';
import { CommunityRowView } from './CommunityRowView';
import { communityMessages as messages } from './communityMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for Outreach; each part uses its own slice of it */
import shared from '../Outreach.module.scss';
import styles from './Communities.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface CommunityTableProps {
  rows: CommunityRow[];
}

/** The community table of "Where you can post yourself" (design outreach r1). */
const CommunityTableComponent: React.FC<CommunityTableProps> = ({ rows }) => {
  const intl = useIntl();
  const items = useMemo(() => rows.map((row) => <CommunityRowView key={row.uuid} row={row} />), [rows]);
  return (
    <Panel as="section">
      <div className={shared.table} data-testid="community-table">
        <div className={clsx(shared.tableRow, shared.tableHead, styles.communityRow)}>
          <span />
          <span>{intl.formatMessage(messages.colCommunity)}</span>
          <span className={clsx(shared.cellNum, styles.hideNarrow)}>{intl.formatMessage(messages.colMembers)}</span>
          <span className={styles.hideNarrow}>{intl.formatMessage(messages.colRules)}</span>
          <span className={styles.hideNarrow}>{intl.formatMessage(messages.colSelfPromo)}</span>
          <span />
        </div>
        {items}
      </div>
    </Panel>
  );
};

export const CommunityTable = TypedMemo(CommunityTableComponent);
